// Cài đặt hiển thị lưu cục bộ trên trình duyệt (không phải dữ liệu nghiệp vụ
// nên không cần lưu Firestore) — hiện chỉ có kích thước ảnh QR khi tải xuống.
// Người dùng nhập theo cm (kích thước thật khi in dán lên vườn/sọt), quy
// đổi sang px theo chuẩn in 300dpi khi tạo ảnh QR.

const KHOA_KICH_THUOC_QR_CM = "caiDat.kichThuocQrTaiXuongCm";
const KICH_THUOC_QR_MAC_DINH_CM = 4;
const DPI_IN = 300;

export function cmSangPx(cm) {
  return Math.round((Number(cm) / 2.54) * DPI_IN);
}

export function layKichThuocQrMacDinhCm() {
  const gt = Number(localStorage.getItem(KHOA_KICH_THUOC_QR_CM));
  return gt > 0 ? gt : KICH_THUOC_QR_MAC_DINH_CM;
}

export function luuKichThuocQrMacDinhCm(cm) {
  localStorage.setItem(KHOA_KICH_THUOC_QR_CM, String(cm));
}

export { KICH_THUOC_QR_MAC_DINH_CM, DPI_IN };
